import { render, staticRenderFns } from "./listlabel.vue?vue&type=template&id=77689254&scoped=true&"
import script from "./listlabel.vue?vue&type=script&lang=js&"
export * from "./listlabel.vue?vue&type=script&lang=js&"
import style0 from "./listlabel.vue?vue&type=style&index=0&id=77689254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77689254",
  null
  
)

export default component.exports